export const MVA_AUTH_TOKEN_TAG = 'jwtToken';
export const MVA_LOGGED_IN_USER = 'user';
export const MVA_CONFIG = 'config';
export const MOMENT_TIME_FORMAT = 'MMM D, YYYY h:mm:ss a';
export const MOMENT_DATE_FORMAT = 'MMM D, YYYY';
export const MOMENT_MONTH_FORMAT = 'MMM YYYY';
export const MOMENT_DATE_FORMAT_GRAPHQL = 'YYYY-MM-DD';
export const ROWS_PER_PAGE = 20;
export const FETCH_TIMEOUT = 10000;

export const COLOR_UNDEFINED = '#d9d9d9';
export const COLOR_MATCHED = '#005a00';
export const COLOR_FUND = '#00a6c7';
export const COLOR_LIGHT_GREEN = '#00aa00';

export const COLOR_FILLED = '#00aa00';
export const COLOR_EXCHANGE_OPEN = COLOR_LIGHT_GREEN;
export const COLOR_EXCHANGE_TO_OPEN = '#faa222';

export const COLOR_HALO_DARK = '#264a80';
export const COLOR_HALO_LIGHT = '#55c3ef';
export const CS_COLOR = '#00a6c7';
export const IB_COLOR = '#D81222';
export const BK_COLOR = '#000000';


export const orderColorMap = {
  FIL: { backgroundColor: '#00aa00', color: 'white' },
  INM: { backgroundColor: '#6e6e6e', color: 'white' },
  CRE: { backgroundColor: '#6e6e6e', color: 'white' },
  PEX: { backgroundColor: '#9a8aaa', color: 'white' },
  REJ: { backgroundColor: '#c70202', color: 'white' },
  CAN: { backgroundColor: '#faa222', color: 'white' },
  POS: { backgroundColor: '#442273', color: 'white' },
  INI: { backgroundColor: '#2b728c', color: 'white' },
  PFL: { backgroundColor: '#82ab8a', color: 'white' },
  QUE: { backgroundColor: '#74a0c7', color: 'black' },
  MATCH: { backgroundColor: COLOR_MATCHED, color: 'white' },
};

export const muiGridSizes = ['xs', 'sm', 'md', 'lg', 'xl'];
export const mimeTypes = {
  csv: [
    '.csv',
    'text/csv',
    'application/vnd.ms-excel',
    'application/csv',
    'text/x-csv',
    'application/x-csv',
    'text/comma-separated-values',
    'text/x-comma-separated-values',
  ],
  excel: [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
};
